export const STOPWORDS = [
  'de',
  'a',
  'o',
  'que',
  'e',
  'do',
  'da',
  'em',
  'um',
  'para',
  'é',
  'com',
  'uma',
  'os',
  'no',
  'se',
  'na',
  'por',
  'mais',
  'as',
  'dos',
  'como',
  'mas',
  'foi',
  'ao',
  'ele',
  'das',
  'tem',
  'à direita',
  'à esquerda',
  'à',
  'seu',
  'sua',
  'ou',
  'ser',
  'quando',
  'muito',
  'há',
  'nos',
  'já',
  'está',
  'eu',
  'também',
  'só',
  'pelo',
  'pela',
  'até',
  'isso',
  'ela',
  'entre',
  'era',
  'depois',
  'sem',
  'mesmo',
  'aos',
  'ter',
  'seus',
  'quem',
  'nas',
  'me',
  'esse',
  'eles',
  'estão',
  'você',
  'tinha',
  'foram',
  'essa',
  'num',
  'nem',
  'suas',
  'meu',
  'às',
  'minha',
  'têm',
  'numa',
  'pelos',
  'elas',
  'havia',
  'seja',
  'qual',
  'será',
  'nós',
  'tenho',
  'lhe',
  'deles',
  'essas',
  'esses',
  'pelas',
  'este',
  'fosse',
  'dele',
  'tu',
  'te',
  'vocês',
  'vos',
  'lhes',
  'meus',
  'minhas',
  'teu',
  'tua',
  'teus',
  'tuas',
  'nosso',
  'nossa',
  'nossos',
  'nossas',
  'dela',
  'delas',
  'esta',
  'estes',
  'estas',
  'aquele',
  'aquela',
  'aqueles',
  'aquelas',
  'isto',
  'aquilo',
  'estou',
  'está',
  'estamos',
  'estão',
  'estive',
  'esteve',
  'estivemos',
  'estiveram',
  'estava',
  'estávamos',
  'estavam',
  'estivera',
  'estivéramos',
  'esteja',
  'estejamos',
  'estejam',
  'estivesse',
  'estivéssemos',
  'estivessem',
  'estiver',
  'estivermos',
  'estiverem',
  'hei',
  'há',
  'havemos',
  'hão',
  'houve',
  'houvemos',
  'houveram',
  'houvera',
  'houvéramos',
  'haja',
  'hajamos',
  'hajam',
  'houvesse',
  'houvéssemos',
  'houvessem',
  'houver',
  'houvermos',
  'houverem',
  'houverei',
  'houverá',
  'houveremos',
  'houverão',
  'houveria',
  'houveríamos',
  'houveriam',
  'sou',
  'somos',
  'são',
  'era',
  'éramos',
  'eram',
  'fui',
  'foi',
  'fomos',
  'foram',
  'fora',
  'fôramos',
  'seja',
  'sejamos',
  'sejam',
  'fosse',
  'fôssemos',
  'fossem',
  'for',
  'formos',
  'forem',
  'serei',
  'será',
  'seremos',
  'serão',
  'seria',
  'seríamos',
  'seriam',
  'tenho',
  'tem',
  'temos',
  'tém',
  'tinha',
  'tínhamos',
  'tinham',
  'tive',
  'teve',
  'tivemos',
  'tiveram',
  'tivera',
  'tivéramos',
  'tenha',
  'tenhamos',
  'tenham',
  'tivesse',
  'tivéssemos',
  'tivessem',
  'tiver',
  'tivermos',
  'tiverem',
  'terei',
  'terá',
  'teremos',
  'terão',
  'teria',
  'teríamos',
  'teriam',
  'em silêncio',
  'às claras',
  'de cor',
  'à vontade',
  'à toa',
  'às pressas',
  'de mansinho',
  'Em breve',
  'à tarde',
  'à noite',
  'depois de amanhã',
  'de repente',
  'hoje em dia',
  'de madrugada',
  'de manhã',
  'de vez em quando',
  'De jeito nenhum',
  'de modo algum',
  'De novo',
  'de pouco',
  'de todo',
  'Quem sabe',
  'Por certo',
  'sem dúvida',
  'com certeza',
  'Por fora',
  'por dentro',
  'em cima',
  'ao lado',
  'por baixo',
  'por cima',
  'por perto',
];

/** Termos banidos como palavras-chave (tags) - sem valor para busca */
export const TAG_BLACKLIST = [
  'teste', 'anonimo', 'exemplo', 'exemplos',
  'novembro', 'dezembro', 'janeiro', 'fevereiro', 'marco',
  'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro',
  'promptus', 'default', 'temp', 'tmp',
];

/**
* TJC = Termos Jurídicos Compostos
*
*/
export const TJC = [
    /agravo (de instrumento|em recurso especial|regimental|interno)/gi,
    /arguição de (inconstitucionalidade|suspeição)/gi,
    /amicus curiae/gi,
    /ação (judicial|penal (pública|privada)|rescisória)/gi,
    /ad (cautelam|hoc|quem)/gi,
    /advogado dativo/gi,
    /habeas (corpus|data)/gi,
    /alvará de soltura/gi,
    /ata de (audiência|julgamento)/gi,
    /ato (ordinário|processual)/gi,
    /audiência de (conciliação|custódia|Instrução de julgamento)/gi,
    /autos do processo/gi,
    /aviso de recebimento/gi,
    /baixa (à origem|em diligência)/gi,
    /bis in idem/gi,
    /boa-fé/gi,
    /carta precatória/gi,
    /cartório judicial/gi,
    /caso fortuito/gi,
    /causa mortis/gi,
    /central de mandados/gi,
    /certidão de (decurso de prazo|objeto e pé)/gi,
    /código ((de processo ){0,1}(civil|penal)|de defesa do consumidor)/gi,
    /(com|sem) resolução d(e|o) mérito/gi,
    /conflito de competência/gi,
    /conselho (da magistratura|recursal|nacional de justiça)/gi,
    /custas processuais/gi,
    /danos? (materia|mora)(l|is)/gi,
    /data venia/gi,
    /decisão (interlocutória|judicial|monocrática)/gi,
    /declínio de competência/gi,
    /defensoria pública/gi,
    /denúncia do contrato/gi,
    /desembargador (relator|revisor|vogal)/gi,
    /devolução do prazo/gi,
    /diário (da justiça eletrônico|oficial)/gi,
    /dilação de prazo/gi,
    /direito líquido e certo/gi,
    /duplo grau de jurisdição/gi,
    /edital( de (citação|leilão)|-pauta)/gi,
    /efeito suspensivo/gi,
    /(em|retirada de) (mesa|pauta)/gi,
    /embargos de declaração/gi,
    /escritura pública/gi,
    /ex (lege|nunc|positis|tunc|vi legis)/gi,
    /executado judicial/gi,
    /execução sentença/gi,
    /expedição de documento/gi,
    /expediente forense/gi,
    /(extra|ultra) petita/gi,
    /flagrante delito/gi,
    /força maior/gi,
    /fumus boni iuris/gi,
    /gratuidade de justiça/gi,
    /grupo de câmara criminal/gi,
    /homologação de acordo/gi,
    /honorários (advocatícios|de sucumbência)/gi,
    /(impedimento|suspeição) do magistrado/gi,
    /(im)?procedência do pedido/gi,
    /julgo (im)?procedente/gi,
    /in (albis|fine|totum)/gi,
    /inquérito policial/gi,
    /instância superior/gi,
    /interpretação pacífica/gi,
    /intimação eletrônica/gi,
    /ipsis literis/gi,
    /ipso facto/gi,
    /juiz leigo/gi,
    /juizado especial (cível|criminal|fazendário)/gi,
    /juízo (100% digital|de admissibilidade)/gi,
    /julgamento monocrático/gi,
    /(lato|stricto) sensu/gi,
    /ma-fé/gi,
    /malote digital/gi,
    /mandado de (busca e apreensão|citação|injunção|pagamento|prisão|segurança)/gi,
    /medida (socioeducativa|protetiva)/gi,
    /mens legis/gi,
    /ministério público/gi,
    /modus operandi/gi,
    /mora ex re/gi,
    /oficial de justiça/gi,
    /ônus da prova/gi,
    /ordem dos advogados do Brasil/gi,
    /órgão julgador (colegiado)?/gi,
    /para (processar|publicar)/gi,
    /parecer (do ministério público|técnico)/gi,
    /pari passu/gi,
    /(pauta|sessão) de julgamento/gi,
    /pedido de liminar/gi,
    /pedindo dia/gi,
    /petição inicial/gi,
    /poder (legislativo|executivo|judiciário)/gi,
    /poderes da procuração/gi,
    /(precatório|processo|unidade) judicial/gi,
    /prazo de \d+ \(\w+\) dias/gi,
    /prima facie/gi,
    /prisão em flagrante/gi,
    /pro forma/gi,
    /processo(s)? (eletrônico(s)?)/gi,
    /procuradoria geral (da República|do Estado( do Pará)?|do Município( de \w+)?)/gi,
    /progressão de (regime|pena)/gi,
    /projeto de sentença/gi,
    /queixa-crime/gi,
    /questão constitucional/gi,
    /recesso do Judiciário/gi,
    /recurso (especial|extraordinário|inominado|ordinário|repetitivo)/gi,
    /renúncia de mandato/gi,
    /repercussão geral/gi,
    /representante legal/gi,
    /seções cíveis/gi,
    /seção de direito (público|privado)/gi,
    /secretaria de Câmara/gi,
    /Substabelecimento (com|sem) Reserva de Poderes/gi,
    /trânsito em Julgado/gi,
    /Tribuna(l Pleno|is Superiores)/gi,
    /vara de origem/gi,
    /vista dos autos/gi,
    /Voto vencido/gi
]
